import React from 'react';
import Card from '../card/Card';
import P from '../texts/p/P';
import Modal from '../modal/modal';

export interface AnnulAvalDialogGuarantee {
  id_global: string;
  monetization_amount?: number | null;
  application_product_line_id?: number | null;
  product_label?: string | null;
  currency_code?: string | null;
}

interface AnnulMonetizationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  guarantee: AnnulAvalDialogGuarantee | null;
  isLoading?: boolean;
}

const AnnulMonetizationDialog: React.FC<AnnulMonetizationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  guarantee,
  isLoading = false,
}) => {
  if (!guarantee) return null;

  const formatCurrency = (amount: number) => amount.toLocaleString('es-AR');
  const currencyCode = guarantee.currency_code || 'ARS';
  const lineNumber = guarantee.application_product_line_id ?? '-';
  const productLabel = guarantee.product_label || '-';
  const amountLabel = guarantee.monetization_amount != null
    ? `${currencyCode} ${formatCurrency(guarantee.monetization_amount)}`
    : '-';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title='¿Anular este aval?'
      onSecondaryAction={onClose}
      secondaryVariant='tertiary'
      secondaryText='Cancelar'
      onPrimaryAction={onConfirm}
      primaryVariant='danger'
      primaryText='Anular aval'
      primaryActionDisabled={isLoading}
      loadingPrimaryBtn={isLoading}
      width='480px'
    >
      <Card margin={{ top: '3', bottom: '3' }}>
        <P type='2' weight='regular' modifier='regular' withMargin={false}>
          Estás por anular el aval Nº {guarantee.id_global} (línea {lineNumber}) del producto{' '}
          {productLabel} por {amountLabel}.
        </P>
        <Card margin={{ top: '2' }}>
          <P type='3' weight='regular' modifier='regular' withMargin={false}>
            El monto se liberará y volverá a estar disponible para cargar nuevos avales.
          </P>
        </Card>
        <Card margin={{ top: '2' }}>
          <P type='3' weight='regular' modifier='weak' withMargin={false}>
            Esta acción no se puede deshacer.
          </P>
        </Card>
      </Card>
    </Modal>
  );
};

export default AnnulMonetizationDialog;
